"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDrag;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function useDrag() {
  const [clicked, setClicked] = _react.default.useState(false);
  const [dragging, setDragging] = _react.default.useState(false);
  const position = _react.default.useRef(0);
  const dragStart = _react.default.useCallback(ev => {
    position.current = ev.clientX;
    setClicked(true);
  }, []);
  const dragStop = _react.default.useCallback(() => window.requestAnimationFrame(() => {
    setDragging(false);
    setClicked(false);
  }), []);
  const dragMove = (ev, cb) => {
    const newDiff = position.current - ev.clientX;
    const movedEnough = Math.abs(newDiff) > 5;
    if (clicked && movedEnough) {
      setDragging(true);
    }
    if (dragging && movedEnough) {
      position.current = ev.clientX;
      cb(newDiff);
    }
  };
  return {
    dragStart,
    dragStop,
    dragMove,
    dragging,
    position,
    setDragging
  };
}
//# sourceMappingURL=useDrag.js.map